var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _mask, _g, _path14;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.225 84.403h-.79V8.174H.79v76.23H0V4.43A4.44 4.44 0 014.44 0h154.344a4.44 4.44 0 014.441 4.43v79.973zm-.79-79.973v2.956H.79V4.43A3.65 3.65 0 014.44.788h154.344a3.65 3.65 0 013.651 3.642zm-4.239.88a1.12 1.12 0 100-2.239c-.62 0-1.123.501-1.123 1.12 0 .619.503 1.12 1.123 1.12zm-2.59-1.12c0 .62-.503 1.12-1.122 1.12-.62 0-1.123-.5-1.123-1.12a1.122 1.122 0 012.245 0zm-4.834 1.12a1.12 1.12 0 100-2.239 1.121 1.121 0 100 2.24z",
    fill: "#DFDDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.225 78.802l9.925 9.925 9.925-9.925-9.925-9.925-9.925 9.925zm9.925 11.435L17.716 78.802 29.15 67.367l11.435 11.435L29.15 90.237zM155.081 116h-1.138V83.663c0-8.794-5.916-16.333-14.43-18.453a20.646 20.646 0 01-15.848 7.368 20.646 20.646 0 01-15.848-7.368c-8.513 2.12-14.43 9.659-14.43 18.453V116H92.25V83.663c0-9.443 6.437-17.52 15.652-19.642l.347-.08.223.276a19.516 19.516 0 0015.194 7.225 19.513 19.513 0 0015.194-7.225l.224-.275.346.08c9.216 2.12 15.652 10.198 15.652 19.641V116zM116.618 30.027c-1.23 0-2.231.998-2.231 2.226a2.231 2.231 0 004.463 0 2.232 2.232 0 00-2.232-2.226zm0 5.588a3.369 3.369 0 01-3.369-3.362 3.37 3.37 0 016.739 0 3.37 3.37 0 01-3.37 3.362zm-2.521 26.633h9.166c7.972 0 14.458-6.47 14.458-14.423V29.892c0-7.953-6.486-14.422-14.458-14.422s-14.457 6.47-14.457 14.422v13.822h5.291v18.534zm9.166 1.136h-10.304V44.85h-5.292V29.892c0-8.579 6.997-15.559 15.596-15.559 8.6 0 15.596 6.98 15.596 15.56v17.932c0 8.58-6.996 15.559-15.596 15.559zM76.788 27.95H26.011c-.623 0-1.128-.642-1.128-1.433 0-.792.505-1.433 1.128-1.433h50.777c.623 0 1.129.64 1.129 1.433 0 .791-.506 1.433-1.129 1.433z",
    fill: "#DFDDE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.208 27.95H17.09c-.051 0-.092-.642-.092-1.433 0-.792.041-1.433.091-1.433h4.118c.05 0 .091.64.091 1.433 0 .791-.04 1.433-.091 1.433z",
    fill: "#F3F2F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.238 34.4h-26.76c-.329 0-.595-.642-.595-1.433 0-.792.266-1.433.595-1.433h26.76c.329 0 .595.64.595 1.433 0 .791-.266 1.433-.595 1.433z",
    fill: "#B3ADC8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.413 34.4H54.769c-.278 0-.503-.642-.503-1.433 0-.792.225-1.433.503-1.433h22.644c.278 0 .503.64.503 1.433 0 .791-.225 1.433-.503 1.433z",
    fill: "#DFDDE6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.788 54.467H26.011c-.623 0-1.128-.642-1.128-1.434 0-.791.505-1.433 1.128-1.433h50.777c.623 0 1.129.642 1.129 1.433 0 .792-.506 1.434-1.129 1.434z",
    fill: "#D2CFDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.208 34.4H17.09c-.051 0-.092-.642-.092-1.433 0-.792.041-1.433.091-1.433h4.118c.05 0 .091.64.091 1.433 0 .791-.04 1.433-.091 1.433zM21.208 54.467H17.09c-.051 0-.092-.642-.092-1.434 0-.791.041-1.433.091-1.433h4.118c.05 0 .091.642.091 1.433 0 .792-.04 1.434-.091 1.434z",
    fill: "#F3F2F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.337 41.567H51.262c-.32 0-.58-.802-.58-1.792s.26-1.791.58-1.791h26.075c.32 0 .58.801.58 1.791 0 .99-.26 1.792-.58 1.792z",
    fill: "#B3ADC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.627 41.567H25.356c-.262 0-.473-.802-.473-1.792s.212-1.791.473-1.791h21.27c.262 0 .474.801.474 1.791 0 .99-.212 1.792-.473 1.792z",
    fill: "#DFDDE6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.208 41.567H17.09c-.051 0-.092-.802-.092-1.792s.041-1.791.091-1.791h4.118c.05 0 .091.801.091 1.791 0 .99-.04 1.792-.091 1.792z",
    fill: "#F3F2F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.558 48.017H26.024c-.63 0-1.141-.642-1.141-1.434 0-.79.51-1.433 1.141-1.433h28.534c.63 0 1.142.642 1.142 1.433 0 .792-.511 1.434-1.142 1.434zM77.146 48.017H57.902c-.425 0-.77-.642-.77-1.434 0-.79.346-1.433.77-1.433h19.244c.426 0 .77.642.77 1.433 0 .792-.344 1.434-.77 1.434z",
    fill: "#DFDDE6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.14 48.017h-3.982c-.088 0-.159-.642-.159-1.434 0-.79.071-1.433.16-1.433h3.98c.089 0 .16.642.16 1.433 0 .792-.071 1.434-.16 1.434z",
    fill: "#F3F2F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.87 64.321c7.125 0 12.9-5.775 12.9-12.9 0-7.124-5.775-12.9-12.9-12.9-7.124 0-12.9 5.776-12.9 12.9 0 7.125 5.776 12.9 12.9 12.9zM90.995 67.546l-7.014-7.014",
    stroke: "#4D3BD7",
    strokeWidth: 3.583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 78,
    width: 25,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.683 78.834h23.32v23.324h-23.32V78.834z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.674 101.172h21.344V79.825c-11.654.261-21.084 9.694-21.344 21.347zm22.33.986H50.682v-.492c0-12.587 10.24-22.83 22.827-22.832h.493v23.324z",
    fill: "#DFDDE6"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.783 102.484h-.993c0-2.577-1.966-4.674-4.382-4.674-2.416 0-4.382 2.097-4.382 4.674h-.993c0-3.161 2.411-5.733 5.375-5.733s5.375 2.572 5.375 5.733z",
    fill: "#DFDDE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.98471ed9.svg";
export { ForwardRef as ReactComponent };